/**
 * Used for generating requests in QuotesAPI
 */

export const fieldApi = {
    productTerm: {api: [{api: 'ixn', name: 'carrier_ids[]'}], type: 'select'},
    productGUL: {api: [{api: 'ixn', name: 'carrier_ids[]'}], type: 'select'},
    healthRatingLSWIUL: {api: [{api: 'winflex', name: 'Insured.Class'}], type: 'select'},
    healthRatingAmeritasJuvenile: {api: [{api: 'winflex', name: 'Insured.Class'}], type: 'select'},
    healthRatingAmeritasAdult: {api: [{api: 'winflex', name: 'Insured.Class'}], type: 'select'},
    healthRatingAmeritasTerm: {api: [{api: 'ixn', name: 'health_categories[]'}], type: 'select'},
    smokerRatingAmeritasTerm: {api: [{api: 'ixn', name: 'tobacco'}], type: 'select'},
    smokerRatingAssurityTerm: {api: [{api: 'ixn', name: 'tobacco'}], type: 'select'},
    healthRatingMOOIUL: {api: [{api: 'winflex', name: 'Insured.Class'}], type: 'select'},
    healthRatingMOOWHL: {api: [{api: 'winflex', name: 'Insured.Class'}], type: 'select'},
    healthRatingFGIUL: {api: [{api: 'winflex', name: 'Insured.Class'}], type: 'select'},
    tableRatingFGIUL: {api: [{api: 'winflex', name: 'Insured.Table'}], type: 'select'},
    healthRatingLSW: {api: [{api: 'ixn', name: 'health_categories[]'}], type: 'select'},
    healthRatingAssurityTerm: {api: [{api: 'ixn', name: 'health_categories[]'}], type: 'select'},
    smokerRatingLSW: {api: [{api: 'ixn', name: 'tobacco'}], type: 'select'},
    healthRatingNA: {api: [{api: 'ixn', name: 'health_categories[]'}], type: 'select'},
    smokerRatingNA: {api: [{api: 'ixn', name: 'tobacco'}], type: 'select'},
    healthRatingMOO: {api: [{api: 'ixn', name: 'health_categories[]'}], type: 'select'},
    smokerRatingMOO: {api: [{api: 'ixn', name: 'tobacco'}], type: 'select'},
    tableRatingAmeritas: {
        api: [
            {api: 'winflex', name: 'Insured.Table'},
            {api: 'ixn', name: 'table_rates[]'},
        ],
        type: 'select',
    },
    tableRatingLSWIUL: {api: [{api: 'winflex', name: 'Insured.Table'}], type: 'select'},
    tableRatingLSWIUL2: {api: [{api: 'winflex', name: 'Insured.Table'}], type: 'select'},
    tableRatingAmeritasTerm: {
        api: [
            {api: 'winflex', name: 'Insured.Table'},
            {api: 'ixn', name: 'table_rates[]'},
        ],
        type: 'select',
    },
    tableRatingLSW: {api: [{api: 'ixn', name: 'table_rates[]'}], type: 'select'},
    tableRatingNA: {api: [{api: 'ixn', name: 'table_rates[]'}], type: 'select'},
    flatExtraPerm: {
        api: [
            {api: 'winflex', name: 'Insured.ExtraPerm'},
            {api: 'ixn', name: 'flat_extra'},
        ],
        type: 'currency',
    },
    flatExtraYears: {api: [{api: 'winflex', name: 'Insured.ExtraTemp'}], type: 'number'},
    flatExtraTemp: {api: [{api: 'winflex', name: 'Insured.ExtraTemp'}], type: 'currency'},
    specifiedFaceAmount: {api: [{api: 'ixn', name: 'face_amount'}], type: 'currency'},
    specifiedFaceAmountWinflex: {api: [{api: 'winflex', name: 'Policy.FaceAmount'}], type: 'currency'},
    specifiedFaceAmountMOO: {api: [{api: 'ixn', name: 'face_amount'}], type: 'currency'},
    complianceTest: {api: [{api: 'winflex', name: 'Policy.InsuranceTest'}], type: 'select'},
    mecAvoidance: {api: [{api: 'winflex', name: 'Policy.PreventMEC'}], type: 'boolean'},
    deathBenefitOption: {
        api: [
            {
                api: 'winflex',
                name: 'Policy.DBOpt',
                value: [
                    {start: 'age', end: 'deathBenefitChangeYear', answer: 'deathBenefitOption'},
                    {start: 'deathBenefitChangeYear+1', end: '121', answer: 'Level'},
                ],
            },
        ],
        type: 'select',
    },
    deathBenefitOptionFGPathsetter: {
        api: [
            {
                api: 'winflex',
                name: 'Policy.DBOpt',
                value: [
                    {start: 'age', end: 'deathBenefitChangeYearFGPathsetter', answer: 'deathBenefitOptionFGPathsetter'},
                    {start: 'deathBenefitChangeYearFGPathsetter+1', end: '121', answer: 'Level'},
                ],
            },
        ],
        type: 'select',
    },
    //deathBenefitOptionMOOIUL: {api: [{api: 'winflex', name: 'Policy.DBOpt'}], type: 'select'},
    solveForIUL: {api: [{api: 'winflex', name: 'Policy.SolveFor'}], type: 'select'},
    solveForIULMoo: {api: [{api: 'winflex', name: 'Policy.SolveFor'}], type: 'select'},
    solveForWHLMoo: {api: [{api: 'winflex', name: 'Policy.SolveFor'}], type: 'select'},
    solveForTAFE: {type: 'select'},
    solveForIULFGPathsetter: {api: [{api: 'winflex', name: 'Policy.SolveFor'}], type: 'select'},
    easySolveOptionIULMoo: {api: [{api: 'winflex', name: 'MOM.EasySolve.Option'}], type: 'select'},
    easySolveOptionWHLMoo: {api: [{api: 'winflex', name: 'MOM.EasySolve.Option'}], type: 'select'},
    solveForIULLSW: {api: [{api: 'winflex', name: 'Policy.SolveFor'}], type: 'select'},
    faceAmount: {api: [{api: 'winflex', name: 'Policy.FaceAmount'}], type: 'select'},
    deathBenefitGuaranteeAge: {api: [{api: 'ixn', name: 'product_types[]'}], type: 'select'},
    termPeriod: {api: [{api: 'ixn', name: 'product_types[]'}], type: 'select'},
    termPeriodAssurity: {api: [{api: 'ixn', name: 'product_types[]'}], type: 'select'},
    faceSolveOption: {api: [{api: 'winflex', name: 'Policy.FaceAmount'}], type: 'select'},
    faceSolveOptionFGPathsetter: {api: [{api: 'winflex', name: 'Policy.FaceAmount'}], type: 'select'},
    premiumMode: {api: [{api: 'winflex', name: 'Policy.Premium'}], type: 'select'},
    premiumModeLSW: {api: [{api: 'winflex', name: 'Policy.PremiumMode'}], type: 'select'},
    specifiedPremium: {api: [{api: 'winflex', name: 'Policy.Premium'}], type: 'currency'},
    specifiedPremiumTAFE: {type: 'currency'},
    specifiedFaceAmountTAFE: {type: 'select'},
    specifiedPremiumFGPathsetter: {
        api: [
            {
                api: 'winflex',
                name: 'Policy.Premium',
                value: [
                    {start: 'age', end: 'specifiedPremiumEndAgeFGPathsetter-1', answer: 'specifiedPremiumFGPathsetter'},
                    {start: 'specifiedPremiumEndAgeFGPathsetter', end: '121', answer: '0'},
                ],
            },
        ],
        type: 'select',
    },
    premiumSolveOption: {api: [{api: 'winflex', name: 'Policy.Premium'}], type: 'select'},
    premiumSolveOptionLSW: {api: [{api: 'winflex', name: 'Policy.Premium'}], type: 'select'},
    //premiumSolveOptionFGPathsetter: {api: [{api: 'winflex', name: 'Policy.Premium'}], type: 'select'},
    premiumEndAgeAmeritas: {api: [{api: 'winflex', name: 'Policy.Premium.Sub'}], type: 'select'},
    lumpSumFGPathSetter: {api: [{api: 'winflex', name: 'Policy.PremiumPourin'}], type: 'number'},
    specifiedPremiumEndAgeAmeritas: {api: [{api: 'winflex', name: 'Policy.Premium.Sub'}], type: 'number'},
    //specifiedPremiumEndAgeFGPathsetter: {api: [{api: 'winflex', name: 'Policy.PremiumYears'}], type: 'number'},
    cashValueTargetAge: {api: [{api: 'winflex', name: 'Policy.TargetCVAge'}], type: 'number'},
    cashValueTargetAmount: {api: [{api: 'winflex', name: 'Policy.TargetCV'}], type: 'currency'},
    cashFlowSolveOption: {
        api: [
            {
                api: 'winflex',
                name: 'UNIFI.CashFlow.Premium ',
                value: [
                    {start: 'age', end: 'cashFlowStartAge', answer: '0'},
                    {start: 'cashFlowStartAge+1', end: 'cashFlowEndAge', answer: 'cashFlowSolveOption'},
                    {start: 'cashFlowEndAge+1', end: '121', answer: '0'},
                ],
            },
        ],
        type: 'select',
    },
    premiumFrequency: {api: [{api: 'winflex', name: 'Policy.PremiumMode'}], type: 'select'},
    //premiumFrequencyMOOIUL: {api: [{api: 'winflex', name: 'Policy.PremiumMode'}], type: 'select'},
    //premiumFrequencyFGPathsetter: {api: [{api: 'winflex', name: 'Policy.PremiumMode'}], type: 'select'},
    disbursement: {api: [{api: 'winflex', name: 'Policy.DisburseYN'}], type: 'boolean'},
    incomeOption: {api: [{api: 'winflex', name: 'Policy.DisbursementOpt'}], type: 'select'},
    annualIncomeAmount: {
        api: [
            {
                api: 'winflex',
                name: 'Policy.Disbursement',
                value: [{start: 'incomeStartAge', end: 'incomeEndAge', answer: 'annualIncomeAmount'}],
            },
        ],
        type: 'currency',
    },
    overloanProtection: {api: [{api: 'winflex', name: 'UNIFI.Paid-upEnd'}], type: 'boolean'},
    fixedInterest: {api: [{api: 'winflex', name: 'UNIFI.Fixed.Pct'}], type: 'number'},
    sp1yr: {api: [{api: 'winflex', name: 'UNIFI.Capped.Pct'}], type: 'number'},
    spAdjust: {api: [{api: 'winflex', name: 'UNIFI.CappedAdjust.Pct'}], type: 'number'},
    sp2yr: {api: [{api: 'winflex', name: 'UNIFI.Capped2yr.Pct'}], type: 'number'},
    russell: {api: [{api: 'winflex', name: 'UNIFI.CappedRussell.Pct'}], type: 'number'},
    bnp1yr: {api: [{api: 'winflex', name: 'UNIFI.UncappedBNP1yr.Pct'}], type: 'number'},
    bnp2yr: {api: [{api: 'winflex', name: 'UNIFI.UncappedBNP2yr.Pct'}], type: 'number'},
    acceleratedBenefit: {api: [{api: 'winflex', name: 'Riders.AccDeathBenefit.YN'}], type: 'boolean'},
    accidentalBenefit: {
        api: [
            {api: 'winflex', name: 'Insured.ADB.YN'},
            {api: 'ixn', name: 'adb_rider'},
        ],
        type: 'boolean',
    },
    accidentalBenefitAmount: {api: [{api: 'winflex', name: 'Insured.ADB.Amt'}], type: 'currency'},
    accidentalBenefitRating: {api: [{api: 'winflex', name: 'Insured.RatingADB'}], type: 'select'},
    accidentalBenefitToAge: {api: [{api: 'winflex', name: 'UNIFI.Insured.ADBAge'}], type: 'number'},
    childrensRider: {api: [{api: 'winflex', name: 'Rider.CTR.YN'}], type: 'boolean'},
    childrensRiderAmount: {api: [{api: 'winflex', name: 'Rider.CTR.Amt'}], type: 'currency'},
    childrensRiderToAge: {api: [{api: 'winflex', name: 'UNIFI.ToAge.Insured.CTRAge'}], type: 'number'},
    lifetimeIncomeRider: {api: [{api: 'winflex', name: 'Rider.LifeTimeIllness'}], type: 'boolean'},
    lifetimeIncomeType: {api: [{api: 'winflex', name: 'Rider.IncomeType'}], type: 'select'},
    lifetimeIncomeStartAge: {api: [{api: 'winflex', name: 'Ridar.IncomeStartAge'}], type: 'number'},
    DeathBenefitProtection: {api: [{api: 'winflex', name: 'Rider.GuarDB.YN'}], type: 'boolean'},
};

export const fieldOptions = {
    productType: {options: ['Term', 'IUL', 'LSWIUL', 'Guaranteed', 'Whole Life', 'Prosper']},
    productIUL: {
        options: ['F&G Everlast', 'F&G Pathsetter', 'Ameritas: IUL  - FLX living benefits', 'MOO - IUL Express'],
        optionValues: ['FGEverlast', 'FGPathsetter', '139', 'MOM'],
    },
    productWHL: {
        options: ['MOO: Whole Life', 'TA FE Express'],
        optionValues: ['MOM', 'TAFEExpress'],
    },
    productTerm: {
        options: [
            'Ameritas: FLX Living Benefits Term',
            'North American: Term - ADDvantage',
            'National Life Group: LSW Term',
            'Assurity Life Insurance Company: Term Life Insurance',
        ],
        optionValues: ['163', '139', '1594', '1474'],
    },
    productGUL: {
        options: ['North American: Custom Guarantee Gen 9'],
        optionValues: ['139'],
    },
    productGuaranteed: {
        options: ['Mutual of Omaha: Living Promise', 'Great Western: Final Expense', 'Gerber: Final Expense'],
    },
    productVUL: {options: ['Ameritas: Advisor II VUL']},
    healthRatingLSWIUL: {
        options: [
            'Elite Non-Tobacco',
            'Preferred Non-Tobacco',
            'Standard Non-Tobacco',
            'Express Standard Non-Tobacco 1',
            'Express Standard Non-Tobacco 2',
            'Preferred Tobacco',
            'Standard Tobacco',
            'Express Standard Tobacco',
        ],
        optionValues: ['SP', 'P', 'SN', 'SNT', 'ES1', 'ES2', 'PS', 'ST', 'ET'],
    },
    healthRatingAmeritasJuvenile: {options: ['Juvenile'], optionValues: ['J']},
    healthRatingAmeritasJuvenileVUL: {options: ['Non Tobacco'], optionValues: ['N']},
    healthRatingAmeritasAdult: {
        options: [
            'Preferred Plus',
            'Preferred Non Tobacco',
            'Select Non Tobacco',
            'Rapid Non Tobacco',
            'Non Tobacco',
            'Preferred Tobacco',
            'Rapid Tobacco',
            'Tobacco',
        ],
        optionValues: ['PP', 'P', 'QN', 'RN', 'N', 'PS', 'RS', 'S'],
    },
    healthRatingAmeritasAdultVUL: {
        options: [
            'Preferred Non Tobacco',
            'Non Tobacco',
            'Preferred Tobacco',
            'Tobacco',
            'Preferred Plus',
            'Select Non Tobacco',
        ],
        optionValues: ['P', 'N', 'PS', 'S', 'PP', 'SNT'],
    },
    healthRatingAmeritasTerm: {
        options: [
            'Preferred Plus - only for face amount > $300K',
            'Preferred',
            'Select - only for face amount > $300K',
            'Standard',
            'Rapid',
        ],
        optionValues: ['Preferred Plus', 'Preferred', 'Standard Plus', 'Standard', 'Standard'],
    },
    healthRatingMOOIUL: {
        options: ['Standard Non-Tobacco', 'Standard Tobacco'],
        optionValues: ['N', 'S'],
    },
    healthRatingMOOWHL: {
        options: ['Standard Non-Tobacco', 'Standard Tobacco'],
        optionValues: ['N', 'S'],
    },
    healthRatingTAFE: {
        options: ['Non-Smoker', 'Smoker'],
        optionValues: ['NonSmoker', 'Smoker'],
    },
    healthRatingFGIUL: {
        options: [
            'Preferred Nonsmoker',
            'Preferred Smoker',
            'Standard Nonsmoker',
            'Standard Smoker',
            'Express Standard Nonsmoker',
            'Express Standard Smoker',
        ],
        optionValues: ['P', 'PS', 'N', 'S', 'EN', 'ES'],
    },
    tableRatingFGIUL: {
        options: ['None', 'Table 1', 'Table 2', 'Table 3', 'Table 4', 'Table 5', 'Table 6', 'Table 7', 'Table 8'],
        optionValues: ['', '1', '2', '3', '4', '5', '6', '7', '8'],
    },
    smokerRatingAmeritasTerm: {options: ['Non Tobacco', 'Tobacco']},
    smokerRatingAssurityTerm: {options: ['Non Tobacco', 'Tobacco']},
    healthRatingLSW: {
        options: ['Elite', 'Preferred', 'Select', 'Standard'],
        optionValues: ['Preferred Plus', 'Preferred', 'Standard Plus', 'Standard'],
    },
    healthRatingAssurityTerm: {
        options: ['Preferred Plus', 'Preferred', 'Standard'],
        optionValues: ['Preferred Plus', 'Preferred', 'Standard'],
    },
    smokerRatingLSW: {options: ['Non-Tobacco', 'Tobacco']},
    healthRatingNA: {options: ['Super Preferred', 'Preferred', 'Standard']},
    smokerRatingNA: {options: ['Non Tobacco', 'Tobacco']},
    healthRatingMOO: {options: ['Level', 'Graded']},
    smokerRatingMOO: {options: ['Non-Tobacco', 'Tobacco']},
    tableRatingAmeritas: {
        options: [
            'None',
            'Table A (125%)',
            'Table B (150%)',
            'Table C (175%)',
            'Table D (200%)',
            'Table E (225%)',
            'Table F (250%)',
            'Table G (275%)',
            'Table H (300%)',
        ],
        optionValues: ['None', '1', '2', '3', '4', '5', '6', '7', '8'],
    },
    tableRatingLSWIUL: {
        options: [
            'None',
            'Table B (150%)',
            'Table C (175%)',
            'Table D (200%)',
            'Table E (225%)',
            'Table F (250%)',
            'Table H (300%)',
            'Table J (350%)',
            'Table L (400%)',
            'Table P (500%)',
        ],
        optionValues: ['', '2', '3', '4', '5', '6', '8', '10', '12', '16'],
    },
    tableRatingLSWIUL2: {
        options: [
            'None',
            'Table B (150%)',
            'Table C (175%)',
            'Table D (200%)',
            'Table E (225%)',
            'Table F (250%)',
            'Table H (300%)',
            'Table J (350%)',
            'Table L (400%)',
            'Table P (500%)',
        ],
        optionValues: ['', '2', '3', '4', '5', '6', '8', '10', '12', '16'],
    },
    tableRatingAmeritasTerm: {
        options: [
            'None',
            'Table A (125%)',
            'Table B (150%)',
            'Table C (175%)',
            'Table D (200%)',
            'Table E (225%)',
            'Table F (250%)',
            'Table G (275%)',
            'Table H (300%)',
        ],
        optionValues: ['', 'Table A', 'Table B', 'Table C', 'Table D', 'Table E', 'Table F', 'Table G', 'Table H'],
    },
    tableRatingAmeritasVUL: {
        options: [
            'None',
            'Table A (125%)',
            'Table B (150%)',
            'Table C (175%)',
            'Table D (200%)',
            'Table E (225%)',
            'Table F (250%)',
            'Table H (300%)',
            'Table J (350%)',
            'Table L (400%)',
            'Table P (500%)',
        ],
        optionValues: [
            'None',
            'Table A',
            'Table B',
            'Table C',
            'Table D',
            'Table E',
            'Table F',
            'Table H',
            'Table J',
            'Table L',
            'Table P',
        ],
    },
    tableRatingLSW: {
        options: [
            'None',
            'Table A (125%)/Express Standard 1/Express Tobacco',
            'Table B (150%)',
            'Table C (175%)',
            'Table D (200%)',
            'Table E (225%)/Express Standard 2',
            'Table F (250%)',
            'Table H (300%)',
            'Table J (350%)',
            'Table L (400%)',
            'Table P (500%)',
        ],
        optionValues: [
            'None',
            'Table A',
            'Table B',
            'Table C',
            'Table D',
            'Table E',
            'Table F',
            'Table H',
            'Table J',
            'Table H',
            'Table I',
        ],
    },
    tableRatingNA: {
        options: [
            'None',
            'Rating 2 - 50%',
            'Rating 3 - 75%',
            'Rating 4 - 100%',
            'Rating 5 - 125%',
            'Rating 6 - 150%',
            'Rating 8 - 200%',
            'Rating 10 - 250%',
            'Rating 12 - 300%',
            'Rating 16 - 400%',
        ],
        optionValues: [
            'None',
            'Table B',
            'Table C',
            'Table D',
            'Table E',
            'Table F',
            'Table H',
            'Table J',
            'Table L',
            'Table P',
        ],
    },
    prosperRiskClass: {
        options: [
            'Super Preferred',
            'Non-Tobacco',
            'Preferred Non-Tobacco',
            'Standard Non-Tobacco',
            'Preferred Tobacco',
            'Standard Tobacco',
        ],
        optionValues: [
            'SuperPreferred',
            'NonTobacco',
            'PreferredNonTobacco',
            'StandardNonTobacco',
            'PreferredTobacco',
            'StandardTobacco',
        ],
    },
    prosperPremiumType: {options: ['Target', 'Minimum', 'Maximum']},
    prosperIllustrationROR: {options: ['Target', 'Minimum', 'Maximum']},
    prosperPremiumMode: {options: ['Monthly', 'Annual']},
    prosperPremiumYearsType: {options: ['Age', 'Duration']},
    prosperTableRating: {options: ['', 'A', 'B', 'C', 'D']},
    prosperDeathBenefitOption: {
        options: ['A - Level', 'B - Increasing'],
        optionValues: ['ALevel', 'BIncreasing'],
    },
    prosperTaxTest: {options: ['CVAT', 'GPT']},
    prosperMECTesting: {options: ['Prevent MEC', 'Allow MEC']},
    solveScenario: {
        options: ['Premium - known coverage', 'Coverage - known premium', 'Cashflow - known coverage / premium'],
    },
    solveDetailsPremium: {
        options: [
            'Solve for target premium',
            'Solve for maximum non Mec premium',
            'Solve for minimum premium',
            'Solve for premium with cash value target',
        ],
    },
    solveDetailsCoverage: {
        options: [
            'Solve for target coverage',
            'Solve for minimum coverage - max funding',
            'Solve for coverage with cash value target',
        ],
    },
    specifiedFaceAmountTransGerber: {options: ['5000', '10000', '15000', '20000', '25000']},
    specifiedFaceAmountGW: {
        options: ['5000', '10000', '15000', '20000', '25000', '30000', '35000', '40000'],
    },
    complianceTest: {
        options: ['Guideline Premium Test', 'Cash Value Accumulation Test'],
        optionValues: ['G', 'C'],
    },
    complianceTestLSWIUL: {
        options: ['Cash_Value_Accumulation_Test', 'Guideline_Premium_Test'],
        optionValues: ['Cash_Value_Accumulation_Test', 'Guideline_Premium_Test'],
    },
    complianceTestVUL: {
        options: ['Guideline Premium Test', 'Cash Value Accumulation Test'],
        optionValues: ['G', 'C'],
    },
    mecAvoidanceLSWIUL: {
        options: ['None', 'Adjust_Premiums', 'Adjust_Face'],
        optionValues: ['None', 'Adjust_Premiums', 'Adjust_Face'],
    },
    deathBenefitOption: {options: ['Increasing', 'Level'], optionValues: ['I', 'L']},
    deathBenefitOptionMOOIul: {options: ['Level'], optionValues: ['L']},
    deathBenefitOptionFGPathsetter: {options: ['Increasing', 'Level'], optionValues: ['I', 'L']},
    solveForIUL: {
        options: ['No solve', 'Face amount', 'Premium', 'Cash flow'],
        optionValues: ['C', 'F', 'P', 'M'],
    },
    solveForIULMoo: {
        options: ['Easy Solve'],
        optionValues: ['E'],
    },
    solveForWHLMoo: {
        options: ['Easy Solve', 'No Solve', 'Premium Solve', 'Face Solve'],
        optionValues: ['E', 'C', 'P', 'F'],
    },
    solveForTAFE: {
        options: ['Premium', 'Coverage'],
        optionValues: ['P', 'C'],
    },
    solveForIULFGPathsetter: {
        options: ['No Solve', 'Premium Solve', 'Face Solve'],
        optionValues: ['N', 'P', 'F'],
    },
    easySolveOptionIULMoo: {
        options: ['Premium', 'Face'],
        optionValues: ['P', 'F'],
    },
    easySolveOptionWHLMoo: {
        options: ['Premium', 'Face'],
        optionValues: ['P', 'F'],
    },
    deathBenefitOptionLSWIUL: {
        options: ['B_Increasing', 'A_Level'],
        optionValues: ['B_Increasing', 'A_Level'],
    },
    solveForIULLSW: {
        options: ['No solve', 'Face amount', 'Premium'],
        optionValues: ['N', 'F', 'P'],
    },
    solveTargetLSWIUL: {
        options: ['Endowment', 'Net_Surrender_Value', 'Return_of_Premium'],
        optionValues: ['Endowment', 'Net_Surrender_Value', 'Return_of_Premium'],
    },
    solveForGUL: {options: ['Guaranteed premium']},
    faceAmount: {
        options: ['Minimum Non Mec', 'Target', 'Maximum', 'Specified'],
        optionValues: ['7PAY', 'TGT', 'MAX', 'SPEC'],
    },
    deathBenefitGuaranteeAge: {options: ['To age 121 (No Lapse U/L)', 'To age 100']},
    termPeriod: {
        options: ['10 Year Term', '15 Year Term', '20 Year Term', '30 Year Term'],
    },
    termPeriodAssurity: {
        options: [
            '10 Year Term',
            '15 Year Term',
            '20 Year Term',
            '30 Year Term',
            '20 Year Term ROP',
            '30 Year Term ROP',
        ],
    },
    faceSolveOption: {
        options: ['Endowment', 'Cash value target', 'Cost recovery'],
        optionValues: ['E', 'S', 'C'],
    },
    faceSolveOptionFGPathsetter: {
        options: ['Target'],
        optionValues: ['TGT'],
    },
    premiumMode: {
        options: ['Target', 'Maximum non-Mec', 'Minimum', 'Specified premium'],
        optionValues: ['TGT', 'MNM', 'MIN', 'SPEC'],
    },
    premiumModeLSW: {
        options: ['Annual', 'Semi-annual', 'Quarterly', 'Monthly'],
        optionValues: ['A', 'S', 'Q', 'C'],
    },
    premiumSolveOption: {
        options: ['Endowment', 'Cash value target', 'Cost recovery', 'Pay period'],
    },
    premiumSolveOptionLSW: {
        options: [
            'Solve',
            'Minimum Premium',
            'Death Benefit Proetection Premium',
            'Target',
            'Guideline Level Prem',
            'Guideline Single Prem',
            'Max Non-MEC Premium',
        ],
        optionValues: ['S', 'MIN', 'MGP', 'TGT', 'GDL', 'GDS', '7PAY'],
    },
    premiumSolveOptionFGPathsetter: {
        options: ['Target'],
        optionValues: ['TGT'],
    },

    premiumEndAgeAmeritas: {options: ['max', 'specified age']},
    cashFlowSolveOption: {
        options: ['Endowment', 'Cash value target', 'Cost recovery', 'Paid-up endorsement'],
        optionValues: ['E', 'S', 'C', 'U'],
    },
    premiumFrequency: {
        options: ['annual', 'semi-annual', 'quarterly', 'monthly'],
        optionValues: ['A', 'S', 'Q', 'M'],
    },
    premiumFrequencyTAFE: {
        options: ['Monthly'],
        optionValues: ['M'],
    },
    specifiedFaceAmountTAFE: {
        options: [
            '$5,000',
            '$10,000',
            '$15,000',
            '$20,000',
            '$25,000',
            '$30,000',
            '$35,000',
            '$40,000',
            '$45,000',
            '$50,000',
        ],
        optionValues: ['5000', '10000', '15000', '20000', '25000', '30000', '35000', '40000', '45000', '50000'],
    },
    premiumFrequencyMonthlyOnly: {
        options: ['Monthly'],
        optionValues: ['M'],
    },
    lswPremiumSolveType1: {
        options: ['Specify_Amount', 'Target_Premium', 'Max_Non_MEC_Premium', 'Minimum_Premium_MMP'],
        optionValues: ['Specify_Amount', 'Target_Premium', 'Max_Non_MEC_Premium', 'Minimum_Premium_MMP'],
    },
    lswPremiumSolveType2: {
        options: ['Specify_Amount', 'Target_Premium', 'Max_Non_MEC_Premium', 'Minimum_Premium_MMP'],
        optionValues: ['Specify_Amount', 'Target_Premium', 'Max_Non_MEC_Premium', 'Minimum_Premium_MMP'],
    },
    lswPremiumSolveType3: {
        options: ['Specify_Amount', 'Target_Premium', 'Max_Non_MEC_Premium', 'Minimum_Premium_MMP'],
        optionValues: ['Specify_Amount', 'Target_Premium', 'Max_Non_MEC_Premium', 'Minimum_Premium_MMP'],
    },
    lswPremiumSolveType4: {
        options: ['Specify_Amount', 'Target_Premium', 'Max_Non_MEC_Premium', 'Minimum_Premium_MMP'],
        optionValues: ['Specify_Amount', 'Target_Premium', 'Max_Non_MEC_Premium', 'Minimum_Premium_MMP'],
    },
    lswPremiumSolveType5: {
        options: ['Specify_Amount', 'Target_Premium', 'Max_Non_MEC_Premium', 'Minimum_Premium_MMP'],
        optionValues: ['Specify_Amount', 'Target_Premium', 'Max_Non_MEC_Premium', 'Minimum_Premium_MMP'],
    },
    incomeOption: {options: ['Withdrawals', 'Loans'], optionValues: ['W', 'L']},
    accidentalBenefitRating: {
        options: ['Rating 1.0', 'Rating 1.5', 'Rating 2.0', 'Rating 2.5', 'Rating 3.0'],
        optionValues: ['1.0', '1.5', '2.0', '2.5', '3.0'],
    },
    lifetimeIncomeType: {
        options: ['Level', 'Increasing', 'Potential Increasing'],
        optionValues: ['L', 'I', 'P'],
    },
    solveScenarioVUL: {
        options: [
            'Set premium solve for minimum non mec face amount',
            'Set face amount solve for maximum non mec premium',
            'Set premium solve for target face amount',
            'Set face amount solve for target premium',
        ],
        optionValues: ['1', '2', '3', '4'],
    },
    deathBenefitOptionVUL: {
        options: ['Increasing', 'Level', 'Increasing then Level'],
        optionValues: ['1', '2', '3'],
    },
    productADB: {
        options: ['MOO Guaranteed ADvantage'],
        optionValues: ['MOOGuaranteedADvantage'],
    },
    planTypeADB: {
        options: ['1 Adult', '2 Adults'],
        optionValues: ['1Adult', '2Adults'],
    },
    specifiedCoverageADB: {
        options: [
            '$50,000',
            '$100,000',
            '$150,000',
            '$200,000',
            '$250,000',
            '$300,000',
            '$350,000',
            '$400,000',
            '$450,000',
            '$500,000',
        ],
        optionValues: [
            '50000',
            '100000',
            '150000',
            '200000',
            '250000',
            '300000',
            '350000',
            '400000',
            '450000',
            '500000',
        ],
    },
    // 18-70
    secondCoveredAdultAgeADB: {
        options: Array.from({length: 53}, (_, i) => String(i + 18)),
        optionValues: Array.from({length: 53}, (_, i) => String(i + 18)),
    },
    productAnnuity: {
        options: ['Flex Secure Growth 10'],
        optionValues: ['FlexSecureGrowth10'],
    },
    singlePremiumAnnuity: {
        options: [
            '$0',
            '$5,000',
            '$10,000',
            '$15,000',
            '$20,000',
            '$25,000',
            '$30,000',
            '$35,000',
            '$40,000',
            '$45,000',
            '$50,000',
            '$55,000',
            '$60,000',
            '$65,000',
            '$70,000',
            '$75,000',
            '$80,000',
            '$85,000',
            '$90,000',
            '$95,000',
            '$100,000',
        ],
        optionValues: [
            '0',
            '5000',
            '10000',
            '15000',
            '20000',
            '25000',
            '30000',
            '35000',
            '40000',
            '45000',
            '50000',
            '55000',
            '60000',
            '65000',
            '70000',
            '75000',
            '80000',
            '85000',
            '90000',
            '95000',
            '100000',
        ],
    },
    monthlyPremiumAnnuity: {
        options: ['$100', '$200', '$300', '$400', '$500', '$600', '$700', '$800', '$900', '$1000'],
        optionValues: ['100', '200', '300', '400', '500', '600', '700', '800', '900', '1000'],
    },
    allocationAnnuity: {
        options: ['S&P500 Point-to-Point', 'US Fundamental Balanced Index Point-to-Point'],
        optionValues: ['SP500PointtoPoint', 'USFundamentalBalancedIndexPointtoPoint'],
    },
};
